import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

type ModalExclusaoCarrinhoProps = {
  visivel: boolean,
  hide: any,
  deleteAll: any,
};

type ModalExclusaoCarrinhoState = {
};

class ModalExclusaoCarrinho extends React.Component<ModalExclusaoCarrinhoProps, ModalExclusaoCarrinhoState> {

  constructor(props: ModalExclusaoCarrinhoProps) {
    super(props);

    this.deleteAll = this.deleteAll.bind(this);
    this.fechar = this.fechar.bind(this);
  }

  fechar(): void {
    const { hide } = this.props;
    if (hide) {
      hide();
    }
  }

  deleteAll(): void {
    const { deleteAll } = this.props;
    if (deleteAll) {
      deleteAll();
    }
  }

  render(): any {
    return (
      <Dialog open={this.props.visivel}>
        <DialogContent>
          <div className="modal" id="subs-modal">
            <p className="title">Deseja excluir todos os itens do carrinho ?</p>
            <div className="menu">
              <button onClick={ this.deleteAll } className="confirmar">Sim, desejo excluir</button>
              <button onClick={ this.fechar }>Não</button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

export default ModalExclusaoCarrinho;